module.exports = __webpack_public_path__ + "static/media/moto-just-married-bali-wedding.693c242c.png";